module.exports = require("classnames");


//////////////////
// WEBPACK FOOTER
// external "classnames"
// module id = 2
// module chunks = 0